import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class User_se {
    constructor() {
        this.entity = 'message';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }
    getUser(bId){
        // var formData = new FormData();
        // formData.set("bId",bId)
        return BaseApi({requiresAtuh: true})({
            method: 'GET',

            url: '/private/'+this.entity+'/getUser/?bId='+bId,
            headers: {'Content-Type': 'application/json'},
        })
    }


    save(model) {
        return Api.save(this.entity,model)
    }

    getPage(page_,size_,search,tab) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("tab",tab)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getPageReceive(page_,size_,search) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.append("search",search)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/listReceive/',
            headers: {'Content-Type': 'application/json'},
        })
    }




    detailMsg(page_,size_,msgId,search) {
        let formData = new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.set("id", msgId)
        formData.set("search", search)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/detailMsg/',
            headers: {'Content-Type': 'application/json'},
        })
    }



    getUnReadMessage(){
            return BaseApi({requiresAtuh: true})({
                method: 'GET',
                url: '/private/message/unRead',
                headers: {'Content-Type': 'application/json'},
            })
    }
    readMsgForReceiver(id){
            return BaseApi({requiresAtuh: true})({
                method: 'GET',
                url: '/private/message/read?id='+id,
                headers: {'Content-Type': 'application/json'},
            })
    }
  readMessageForSender(id){
            return BaseApi({requiresAtuh: true})({
                method: 'GET',
                url: '/private/message/readForSender?id='+id,
                headers: {'Content-Type': 'application/json'},
            })
    }


    // search(value,page_,size_){
    //     let search=value;
    //     let formData=new FormData();
    //     formData.set("page",page_)
    //     formData.set("size", size_)
    //     formData.append("search",search,)
    //     return BaseApi({requiresAtuh: true})({
    //         method: 'POST',
    //         data:formData,
    //         url: '/private/'+this.entity+'/search',
    //         headers: {'Content-Type': 'application/json'},
    //     })
    // }
    // searchReceive(value,page_,size_){
    //     let search=value;
    //     let formData=new FormData();
    //     formData.set("page",page_)
    //     formData.set("size", size_)
    //     formData.append("search",search,)
    //     return BaseApi({requiresAtuh: true})({
    //         method: 'POST',
    //         data:formData,
    //         url: '/private/'+this.entity+'/searchReceive',
    //         headers: {'Content-Type': 'application/json'},
    //     })
    // }
    searchDtaile(value,page_,size_,msgId){
        let search=value;
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("id",msgId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/searchDtaile',
            headers: {'Content-Type': 'application/json'},
        })
    }

}
export default new User_se();
